<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
                 style="background-image: url('/images/page-title-bg.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-item text-center">
                            <h3 class="title">Shops</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/">Home</router-link>
                                    </li>
                                    <li class="breadcrumb-item active" aria-current="page">Shops</li>
                                </ol>
                            </nav>
                        </div> <!-- page title item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- row -->
            <div class="page-title-shape">
                <img src="/images/banner-shape.png" alt="shape">
            </div> <!-- page title shape -->
        </section>
        <div class="container">
            <div class="row align-items-center pt-65 pb-20">
                <div class="col-md-4">
                    <div class="product-grid-tab d-flex">
                        <span>{{shops.length}} shops </span>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="product-grid-select float-left float-md-right">
                        <ul>
                            <li>
                                <form class="form-inline" @submit.prevent="searchShops">
                                    <div class="form-group mb-2">
                                        <select v-model="form.sort" class="form-control" @change="sortShops">
                                            <option value="" selected>Sort</option>
                                            <option value="wholesaler">Wholesalers</option>
                                            <option value="retailer">Retailers</option>
                                        </select>
                                    </div>
                                    <div class="form-group mx-sm-3 mb-2">
                                        <input v-model="form.search" type="text" class="form-control"
                                               placeholder="Search Shops">
                                    </div>
                                    <button type="submit" class="btn btn-primary mb-2"><i class="fas fa-search"></i>
                                    </button>
                                </form>
                            </li>
                            <small style="color: red" v-if="error && errors.search">{{ errors.search[0] }}</small>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-6" v-for="shop in pageOfItems" :key="shop.id">
                    <div class="drinks-item mt-5">
                        <img v-if="!shop.shop.profile_image" v-lazy="'/images/drinks-item-1.jpg'"
                             :alt="shop.shop.shop_name">
                        <img v-if="shop.shop.profile_image" v-lazy="'/images/drinks-item-1.jpg'"
                             :alt="shop.shop.shop_name">
                        <span>{{shop.shop.shop_name.charAt(0).toUpperCase() +shop.shop.shop_name.substring(1)}}</span>
                    </div>
                </div>
            </div>
            <div class="mt-100">
                <p class="text-center">
                    <jw-pagination :items="shops" @changePage="onChangePage" :labels="customLabels"
                                   :pageSize="15"></jw-pagination>
                </p>
            </div>
        </div>
        <div class="vld-parent">
            <loading :active.sync="isLoading"
                     :can-cancel="true"
                     :is-full-page="fullPage"></loading>
        </div>
    </div>
</template>

<script>
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";

    const customLabels = {
        first: '<<',
        last: '>>',
        previous: '<',
        next: '>'
    };
    export default {
        name: "Shops",
        components: {
            Loading
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                error: false,
                errors: {},
                pageOfItems: [],
                customLabels,
                shops: [],
                form: {
                    search: '',
                    sort: ''
                }
            }
        },
        methods: {
            sortShops() {
                if (this.form.sort) {
                    this.isLoading = true;
                    try {
                        this.axios.post('/sort-shops', this.form).then((data) => {
                            this.shops = data.data;
                            this.isLoading = false;
                        })
                    } catch (e) {
                        throw new Error(e);
                    }
                }
            },
            onChangePage(pageOfItems) {
                this.pageOfItems = pageOfItems;
            },
            searchShops() {
                this.isLoading = true;
                this.axios.post('/search-shops', this.form).then((data) => {
                    this.shops = data.data
                    this.isLoading = false;
                }).catch((resp) => {
                    this.isLoading = false;
                    this.error = true;
                    this.errors = resp.response.data.errors;
                })
            },
            getShops() {
                try {
                    this.axios.get('/shops').then((data) => {
                        this.shops = data.data
                    })
                } catch (e) {
                    throw new Error(e);
                }
            }
        },
        created() {
            this.getShops();
        }
    }
</script>

<style scoped>

</style>